import { useState, useEffect } from "react";
import api from "../api";
import Modal from "../components/Modal";

export default function Leaves() {
  const now = new Date();
  const [year,     setYear]     = useState(now.getFullYear());
  const [balances, setBalances] = useState([]);
  const [requests, setRequests] = useState([]);
  const [holidays, setHolidays] = useState([]);
  const [ledger,   setLedger]   = useState([]);
  const [types,    setTypes]    = useState([]);
  const [modal,    setModal]    = useState(false);
  const [tab,      setTab]      = useState("balances");
  const [preview,  setPreview]  = useState(null);
  const [form,     setForm]     = useState({
    leave_type_id:"", from_date:"", to_date:"",
    is_half_day:false, half_type:"first", reason:"", attachment_path:"",
  });
  const [msg,      setMsg]      = useState("");

  const load = () => {
    api.get(`/portal/leaves?year=${year}`).then(d => setBalances(d.items||[]));
    api.get(`/portal/leave_requests?year=${year}`).then(d => setRequests(d.items||[]));
    api.get(`/portal/holidays?year=${year}`).then(d => setHolidays(d.items||[]));
    api.get(`/portal/my_leave_ledger?year=${year}`).then(d => setLedger(d.items||[])).catch(()=>{});
  };
  useEffect(() => { load(); }, [year]);
  useEffect(() => { api.get("/portal/leave_types_public").then(d => setTypes(d.leave_types||[])); }, []);

  const selectedType = types.find(t => String(t.id) === String(form.leave_type_id));

  // Live day-count preview whenever dates/half-day/type change
  useEffect(() => {
    if (!form.leave_type_id || !form.from_date || !form.to_date) { setPreview(null); return; }
    api.post("/portal/preview_leave_days", {
      leave_type_id: parseInt(form.leave_type_id),
      from_date: form.from_date, to_date: form.to_date,
      is_half_day: form.is_half_day,
    }).then(d => setPreview(d.days)).catch(() => setPreview(null));
  }, [form.leave_type_id, form.from_date, form.to_date, form.is_half_day]);

  const apply = async () => {
    if (!form.leave_type_id || !form.from_date || !form.to_date) {
      setMsg("Leave type and dates are required."); return;
    }
    if (selectedType?.reason_mandatory && !form.reason.trim()) {
      setMsg("Reason is required for this leave type."); return;
    }
    try {
      await api.post("/portal/leave_requests", {
        leave_type_id: parseInt(form.leave_type_id),
        from_date: form.from_date, to_date: form.to_date,
        is_half_day: form.is_half_day,
        half_type: form.is_half_day ? form.half_type : null,
        reason: form.reason, attachment_path: form.attachment_path,
      });
      setMsg("✓ Applied!"); load();
      setTimeout(() => { setModal(false); setMsg(""); setPreview(null);
        setForm({leave_type_id:"",from_date:"",to_date:"",is_half_day:false,half_type:"first",reason:"",attachment_path:""});
      }, 1200);
    } catch(e) { setMsg(e.message); }
  };

  const cancel = async (id) => {
    if (!confirm("Cancel this request?")) return;
    try { await api.delete(`/portal/leave_requests/${id}`); load(); }
    catch(e) { alert(e.message); }
  };

  const statusPill = s => {
    const map = {pending:"orange",approved:"green",rejected:"red",cancelled:"gray"};
    return <span className={`pill ${map[s]||"gray"}`}>{s}</span>;
  };

  const fmtDate = (ds) => {
    if (!ds) return "—";
    const d = new Date(ds + "T00:00:00");
    const day = String(d.getDate()).padStart(2,"0");
    const mon = d.toLocaleString("en",{month:"short"});
    const yr  = d.getFullYear();
    const dow = d.toLocaleString("en",{weekday:"short"});
    return day+" "+mon+", "+yr+" ("+dow+")";
  };

  return (
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16,flexWrap:"wrap",gap:10}}>
        <div>
          <h2 className="page-title">Leaves</h2>
          <p className="page-sub">Leave balances, requests and holidays</p>
        </div>
        <div style={{display:"flex",gap:8,alignItems:"center"}}>
          <select className="inp" style={{width:"auto"}} value={year}
            onChange={e=>setYear(parseInt(e.target.value))}>
            {[2023,2024,2025,2026,2027].map(y=><option key={y}>{y}</option>)}
          </select>
          <button className="btn" onClick={() => setModal(true)}>+ Apply Leave</button>
        </div>
      </div>

      <div className="tabs">
        {[["balances","Balances"],["requests","My Requests"],["ledger","Ledger"],["holidays","Holidays"]].map(([id,label]) => (
          <button key={id} className={`tab ${tab===id?"active":""}`} onClick={()=>setTab(id)}>{label}</button>
        ))}
      </div>

      {tab === "balances" && (
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(220px,1fr))",gap:12}}>
          {balances.map(b => (
            <div key={b.code} className="card" style={{borderTop:`3px solid ${b.color||"var(--accent)"}`}}>
              <div style={{fontWeight:700,fontSize:15,marginBottom:8}}>{b.name}</div>
              <div style={{fontSize:28,fontWeight:700,color:"var(--accent)"}}>{b.available}</div>
              <div style={{fontSize:12,color:"var(--muted)",marginBottom:10}}>days available</div>
              <div style={{display:"grid",gap:4,fontSize:12}}>
                {[["Allocated",b.allocated],["Carried Fwd",b.carried_forward],["Used",b.used]].map(([k,v])=>(
                  <div key={k} style={{display:"flex",justifyContent:"space-between"}}>
                    <span style={{color:"var(--muted)"}}>{k}</span><span>{v}</span>
                  </div>
                ))}
              </div>
              <div style={{marginTop:8}}>
                <span className={`pill ${b.is_paid?"green":"gray"}`} style={{fontSize:10}}>
                  {b.is_paid?"Paid":"Unpaid"}
                </span>
              </div>
            </div>
          ))}
          {!balances.length &&
            <div className="card" style={{gridColumn:"1/-1",textAlign:"center",color:"var(--muted)"}}>
              No leave balances configured. Ask admin to set up leave types.
            </div>}
        </div>
      )}

      {tab === "requests" && (
        <div className="card">
          <table className="tbl">
            <thead><tr><th>Type</th><th>From</th><th>To</th><th>Days</th><th>Reason</th><th>Status</th><th></th></tr></thead>
            <tbody>
              {requests.map(r => (
                <tr key={r.id}>
                  <td><b>{r.leave_type}</b>{r.is_half_day && <span className="pill blue" style={{marginLeft:6,fontSize:10}}>Half Day</span>}</td>
                  <td>{r.from_date}</td><td>{r.to_date}</td>
                  <td>{r.days}</td>
                  <td style={{maxWidth:200,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{r.reason||"—"}</td>
                  <td>{statusPill(r.status)}</td>
                  <td>{(r.status==="pending"||r.status==="approved") &&
                    <button onClick={()=>cancel(r.id)}
                      style={{background:"none",border:"none",cursor:"pointer",color:"#ef4444",fontSize:12}}>
                      Cancel
                    </button>}
                  </td>
                </tr>
              ))}
              {!requests.length && <tr><td colSpan={7} style={{textAlign:"center",color:"var(--muted)"}}>No requests yet.</td></tr>}
            </tbody>
          </table>
        </div>
      )}

      {tab === "ledger" && (
        <div className="card">
          <table className="tbl">
            <thead><tr><th>Date</th><th>Leave Type</th><th>Transaction</th><th>Qty</th><th>Balance After</th><th>Reason</th></tr></thead>
            <tbody>
              {ledger.map(t => (
                <tr key={t.id}>
                  <td style={{whiteSpace:"nowrap"}}>{t.created_at}</td>
                  <td>{t.leave_type}</td>
                  <td><span className="pill blue" style={{fontSize:10}}>{t.txn_type.replace("_"," ")}</span></td>
                  <td style={{color:t.quantity<0?"#ef4444":"#16a34a",fontWeight:600}}>{t.quantity>0?"+":""}{t.quantity}</td>
                  <td>{t.balance_after}</td>
                  <td style={{color:"var(--muted)"}}>{t.reason||"—"}</td>
                </tr>
              ))}
              {!ledger.length && <tr><td colSpan={6} style={{textAlign:"center",color:"var(--muted)"}}>No transactions yet.</td></tr>}
            </tbody>
          </table>
        </div>
      )}

      {tab === "holidays" && (
        <div className="card">
          <table className="tbl">
            <thead><tr><th>Date</th><th>Holiday</th><th>Type</th><th>Remarks</th></tr></thead>
            <tbody>
              {holidays.map(h => (
                <tr key={h.date}>
                  <td style={{whiteSpace:"nowrap"}}><b>{fmtDate(h.date)}</b></td>
                  <td>{h.name}</td>
                  <td><span className="pill blue">{h.holiday_type}</span></td>
                  <td style={{color:"var(--muted)"}}>{h.remarks||"—"}</td>
                </tr>
              ))}
              {!holidays.length && <tr><td colSpan={4} style={{textAlign:"center",color:"var(--muted)"}}>No holidays configured.</td></tr>}
            </tbody>
          </table>
        </div>
      )}

      {modal && (
        <Modal title="Apply for Leave" onClose={()=>{setModal(false);setMsg("");setPreview(null);}}>
          <div style={{display:"grid",gap:14}}>
            <div>
              <label>Leave Type *</label>
              <select className="inp" value={form.leave_type_id}
                onChange={e=>setForm({...form,leave_type_id:e.target.value})}>
                <option value="">— Select —</option>
                {types.map(t=><option key={t.id} value={t.id}>{t.name}</option>)}
              </select>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
              <div><label>From *</label>
                <input className="inp" type="date" value={form.from_date}
                  onChange={e=>setForm({...form,from_date:e.target.value})}/></div>
              <div><label>To *</label>
                <input className="inp" type="date" value={form.to_date}
                  onChange={e=>setForm({...form,to_date:e.target.value})}/></div>
            </div>
            {selectedType?.allow_half_day && form.from_date && form.from_date === form.to_date && (
              <div style={{display:"flex",gap:14,alignItems:"center"}}>
                <label style={{display:"flex",gap:6,alignItems:"center",fontWeight:400}}>
                  <input type="checkbox" checked={form.is_half_day}
                    onChange={e=>setForm({...form,is_half_day:e.target.checked})}/>
                  Half Day
                </label>
                {form.is_half_day && (
                  <select className="inp" style={{width:"auto"}} value={form.half_type}
                    onChange={e=>setForm({...form,half_type:e.target.value})}>
                    <option value="first">First Half</option>
                    <option value="second">Second Half</option>
                  </select>
                )}
              </div>
            )}
            {preview !== null && (
              <div style={{background:"var(--bg-soft,#f8fafc)",padding:"10px 12px",borderRadius:8,fontSize:13}}>
                <b>{preview}</b> day(s) will be deducted
                {selectedType && (() => {
                  const bal = balances.find(b => b.code === selectedType.code);
                  if (!bal) return null;
                  const remaining = round1(bal.available - preview);
                  return <span style={{color:"var(--muted)"}}> — Available: {bal.available}, Remaining after: {remaining}</span>;
                })()}
              </div>
            )}
            <div><label>Reason {selectedType?.reason_mandatory && "*"}</label>
              <textarea className="inp" rows={3} value={form.reason}
                onChange={e=>setForm({...form,reason:e.target.value})}
                placeholder="Reason for leave…"/>
            </div>
            {selectedType?.require_attachment && (
              <div><label>Attachment {selectedType.attachment_required_above_days == null && "*"}</label>
                <input className="inp" type="text" value={form.attachment_path}
                  placeholder="Attachment upload not yet wired — paste a file reference/URL"
                  onChange={e=>setForm({...form,attachment_path:e.target.value})}/>
              </div>
            )}
            {(() => {
              const bal = selectedType ? balances.find(b => b.code === selectedType.code) : null;
              const noBalance = selectedType && !bal;
              const insufficient = selectedType && bal && preview !== null && preview > bal.available && !selectedType.allow_negative_balance;
              const blocked = !form.leave_type_id || !form.from_date || !form.to_date || noBalance || insufficient;
              return (
                <>
                  {noBalance && <div style={{color:"var(--danger)",fontSize:13,textAlign:"center"}}>No balance allocated for this leave type — contact HR.</div>}
                  {insufficient && <div style={{color:"var(--danger)",fontSize:13,textAlign:"center"}}>Insufficient balance ({bal.available} available, {preview} requested).</div>}
                  <button className="btn full" onClick={apply} disabled={blocked}
                    style={blocked ? {opacity:0.5,cursor:"not-allowed"} : {}}>
                    Submit Application
                  </button>
                </>
              );
            })()}
            {msg && <div style={{textAlign:"center",fontSize:13,color:msg.startsWith("✓")?"var(--ok)":"var(--danger)"}}>{msg}</div>}
          </div>
        </Modal>
      )}
    </div>
  );
}

function round1(n) { return Math.round(n * 10) / 10; }
